const Commerce = (() => {
	return document.body.dataset.country == "kr" ? CommerceKR : CommerceJP;
})();
document.dispatchEvent(new CustomEvent('commerce.load'));